import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ClientService } from '../../../../global/services/client.service';
import { Router } from '@angular/router';
import { Load } from '../../../../global/interfaces/load';
import { LoadService } from '../../../../global/services/load.service';
import { MapService } from '../../../../global/services/map.service';
import { Address } from '../../../../global/interfaces/address';
import { ToastersService } from '../../../../global/services/toasters.service';
import { Toast } from '../../../../global/interfaces/toast';
import { LocationsService } from '../../../../global/services/locations.service';
import { AddressPipe } from '../../directives/address/address.pipe';
import { CountriesService } from '../../../../global/services/countries.service';
import { Country } from '../../../../global/interfaces/country';
import { CountryIso } from '../../../../global/interfaces/countryIso';
import { AddressFunctions } from '../../../../utils/address.functions';
import { TemplateTabs } from '../shared-templates.component';
import { SpecialEquipment } from '../../../../global/enums/SpecialEquipment';
import { Client } from '../../../../global/types/Client';
import { LoadTypeEnum } from '../../../../global/enums/LoadType';
import { MeasureUnit } from '../../../../global/enums/MeasureUnit';
import { PreferredLocation } from '../../../../global/interfaces/prefferedLocation';
import { ClientLocation } from '../../../../global/types/ClientLocation';
import { RigidTrailerType, TrailerType } from '../../../../global/enums/TrailerType';
import { trailerFunctions } from '../../../../utils/trailer.functions';
import { RigidAndArticTrailerType } from '../../../../global/types/RigidAndArticTrailerType';
import { AuthService } from '../../../../global/services/auth.service';
import { PermissionService } from '../../../../global/services/permission.service';
import { PERMISSION_TYPE } from '../../../../global/enums/PermissionType';

@Component({
  selector: 'app-add-new',
  templateUrl: './add-new.component.html',
  styleUrls: ['./add-new.component.less'],
})
export class AddNewComponent implements OnInit {
  @Input() activeTab: TemplateTabs;
  @Input() data;
  @Output() triggerEmitter = new EventEmitter<any>();
  @ViewChild('innerPopup', { static: true }) innerPopup: ElementRef;
  @ViewChild('companyDropbox') companyDropbox: ElementRef;

  clicks = 0;

  client: Client;
  load: Load = { measures: { length: 0, width: 0, height: 0, unit: MeasureUnit.meter } } as Load;
  location: ClientLocation;
  branch: any;

  weightUnits: string[];
  measureUnits: string[];
  loadTypes: string[];

  vehicleRequirements = [
    ...Object.values(TrailerType).map((type) => ({ name: trailerFunctions.trailerTypeToString(type), id: type })),
    ...Object.values(RigidTrailerType).map((type) => ({ name: trailerFunctions.trailerTypeToString(type), id: type })),
  ];

  suggestions: any[] = [];

  editCargo: any = null;
  editClient: Client = null;
  editShippingLocation: any = null;
  editBranch: any = null;
  edit = false;
  existingAddress = '';
  url: string;

  suggestedClients: Client[] = [];
  timeOut: number;

  cargoType: LoadTypeEnum;
  cargoPieces = null;
  cargoWidth = null;
  cargoHeight = null;
  cargoLength = null;
  cargoUnit: MeasureUnit;
  cargoVehicleRequirement: RigidAndArticTrailerType[] = [];
  doubleStacked = false;
  redOutline = false;

  postCodes: any[] = [];
  postalCode: string;
  countries: Country[] = [];
  countryIso: CountryIso;

  // Shipping location related vars
  isDomesticLoad = false;
  addresses: Address[] = [];

  constructor(
    private mapService: MapService,
    private clientService: ClientService,
    private loadService: LoadService,
    private router: Router,
    private toasterService: ToastersService,
    private locationsService: LocationsService,
    private addressPipe: AddressPipe,
    private countriesService: CountriesService,
    private addressFunctions: AddressFunctions,
    private authService: AuthService,
    private permissionService: PermissionService,
  ) {}

  async initCargoForm(data) {
    if (this.edit) this.editCargo = data;
    this.initNewLoad(this.editCargo);
    await this.getLoadData();
  }

  async ngOnInit() {
    const wholeUrl = this.router.url;
    this.url = wholeUrl.split('/')[1];
    this.countries = await this.countriesService.getCountries();
    this.countryIso = await this.locationsService.findIsoCountry(this.countries);
    this.edit = !!this.data;
    const templateForm: { [key in TemplateTabs]: (data?: any) => any } = {
      Cargo: this.initCargoForm.bind(this),
      Clients: this.initNewClient.bind(this),
      ClientLocations: this.initNewShippingLocation.bind(this),
      InnerLocations: this.initNewShippingLocation.bind(this),
    };
    templateForm[this.activeTab](this.edit && this.data);
  }

  @HostListener('document:click', ['$event'])
  onClick(event) {
    if (!this.innerPopup.nativeElement.contains(event.target)) {
      this.clicks += 1;
      if (this.clicks >= 2) {
        this.clicks = 0;
      }
    } else {
      this.clicks = 1;
    }
  }

  get LoadTypeEnum() {
    return LoadTypeEnum;
  }

  initNewClient(client?: Client) {
    if (this.edit) this.editClient = client;
    this.client = {
      name: client?.name ?? '',
      address: {
        id: client?.address?.id ?? '',
        streetNumber: client?.address?.streetNumber ?? '',
        street: client?.address?.street ?? '',
        city: client?.address?.city ?? '',
        state: client?.address?.state ?? '',
        country: client?.address?.country ?? '',
        postalCode: client?.address?.postalCode ?? '',
        latitude: client?.address?.latitude ?? null,
        longitude: client?.address?.longitude ?? null,
        title: client?.address?.title ?? '',
        iso3: client?.address?.iso3 ?? '',
      },
      website: client?.website ?? '',
      contactPerson: client?.contactPerson ?? '',
      phone: client?.phone ?? '',
      email: client?.email ?? '',
    };
    if (client) {
      this.client.id = client?.id;
    }
    this.existingAddress = client?.address ? this.createAddress(client?.address) : '';
  }

  initNewLoad(load?: Load) {
    if (this.edit) this.editCargo = load;
    this.load = {
      name: load?.name ?? '',
      weight: load?.weight ?? null,
      weightUnit: load?.weightUnit ?? null,
      measures: {
        length: load?.measures?.length ?? this.cargoLength,
        width: load?.measures?.width ?? this.cargoWidth,
        height: load?.measures?.height ?? this.cargoHeight,
        unit: load?.measures?.unit ?? this.cargoUnit,
      },
      inPieces: false,
      pieces: load?.pieces ?? this.cargoPieces,
      loadType: load?.loadType ?? this.cargoType,
      vehicleRequirements: load?.vehicleRequirements ?? this.cargoVehicleRequirement,
      specialEquipmentRequirement: load?.specialEquipmentRequirement ?? SpecialEquipment.NONE,
      isTemplate: load?.isTemplate ?? true,
    };
    if (load) {
      this.load.id = load?.id;
    }
  }

  async cargoTemplates(type) {
    this.cargoType = type;
    if (type === 'Standard full pallet') {
      this.cargoPieces = 26;
      this.cargoWidth = 120;
      this.cargoHeight = 200;
      this.cargoLength = 100;
      this.cargoUnit = MeasureUnit.centimeter;
      // eslint-disable-next-line no-unused-vars
      this.cargoVehicleRequirement = [TrailerType.TAUTLINER_13_6M_44FT];
    } else if (type === 'Standard 1/2 pallet') {
      this.cargoPieces = 26;
      this.cargoWidth = 120;
      this.cargoHeight = 110;
      this.cargoLength = 100;
      this.cargoUnit = MeasureUnit.centimeter;
      // eslint-disable-next-line no-unused-vars
      this.cargoVehicleRequirement = [TrailerType.TAUTLINER_13_6M_44FT];
    } else if (type === 'Standard 1/4 pallet') {
      this.cargoPieces = 26;
      this.cargoWidth = 120;
      this.cargoHeight = 80;
      this.cargoLength = 100;
      this.cargoUnit = MeasureUnit.centimeter;
      // eslint-disable-next-line no-unused-vars
      this.cargoVehicleRequirement = [TrailerType.TAUTLINER_13_6M_44FT];
    } else if (type === 'Euro full pallet') {
      this.cargoPieces = 26;
      this.cargoWidth = 120;
      this.cargoHeight = 200;
      this.cargoLength = 80;
      this.cargoUnit = MeasureUnit.centimeter;
      // eslint-disable-next-line no-unused-vars
      this.cargoVehicleRequirement = [TrailerType.TAUTLINER_13_6M_44FT];
    } else if (type === 'Euro 1/2 pallet') {
      this.cargoPieces = 26;
      this.cargoWidth = 120;
      this.cargoHeight = 110;
      this.cargoLength = 80;
      this.cargoUnit = MeasureUnit.centimeter;
      // eslint-disable-next-line no-unused-vars
      this.cargoVehicleRequirement = [TrailerType.TAUTLINER_13_6M_44FT];
    } else if (type === 'Euro 1/4 pallet') {
      this.cargoPieces = 26;
      this.cargoWidth = 120;
      this.cargoHeight = 80;
      this.cargoLength = 80;
      this.cargoUnit = MeasureUnit.centimeter;
      // eslint-disable-next-line no-unused-vars
      this.cargoVehicleRequirement = [TrailerType.TAUTLINER_13_6M_44FT];
    } else {
      this.cargoPieces = null;
      this.cargoWidth = null;
      this.cargoHeight = null;
      this.cargoLength = null;
      this.cargoUnit = null;
      this.cargoVehicleRequirement = [];
      this.load.vehicleRequirements = null;
    }
    this.initNewLoad();
  }
  async changePieces() {
    this.doubleStacked = !this.doubleStacked;
    // eslint-disable-next-line no-unused-vars
    if (this.cargoVehicleRequirement.includes(TrailerType.TAUTLINER_13_6M_44FT)) {
      if (this.doubleStacked) {
        this.cargoPieces = 52;
      } else if (!this.doubleStacked) {
        this.cargoPieces = 26;
      }
    }

    this.initNewLoad();
  }
  async vehicleRequirementsChanges(value) {
    if (
      !this.cargoType &&
      this.cargoType !== LoadTypeEnum.crates &&
      this.cargoType !== LoadTypeEnum.boxes &&
      this.cargoType !== LoadTypeEnum.bags
    ) {
      // eslint-disable-next-line no-unused-vars
      if (
        this.cargoVehicleRequirement.includes(TrailerType.TAUTLINER_13_6M_44FT) &&
        value === TrailerType.BOX_13_6M_44FT
      ) {
        this.redOutline = true;
        this.toasterService.createToast(
          'Info',
          '48’ Foot Dry Van can take 24 single stacked and 48 double stacked standard pallets',
        );
      }
    }
  }

  initNewShippingLocation(location?: PreferredLocation) {
    if (this.edit) this.editShippingLocation = location;
    this.location = {
      id: location?.id ?? undefined,
      client: {
        name: location?.client?.name ?? '',
        website: location?.client?.website ?? '',
        contactPerson: location?.client?.contactPerson ?? '',
        phone: location?.client?.phone ?? '',
        email: location?.client?.email ?? '',
      } as Client,
      clientId: location?.clientId,
      name: location?.name ?? '',
      address: {
        id: location?.address?.id ?? '',
        streetNumber: location?.address?.streetNumber ?? '',
        street: location?.address?.street ?? '',
        city: location?.address?.city ?? '',
        state: location?.address?.state ?? '',
        country: location?.address?.country ?? '',
        postalCode: location?.address?.postalCode ?? '',
        latitude: location?.address?.latitude ?? undefined,
        longitude: location?.address?.longitude ?? undefined,
        title: location?.address?.title ?? '',
        note: location?.address?.note ?? '',
        iso3: location?.address?.iso3,
      },
    };
    if (location) {
      this.location.id = location.id;
    }
    this.existingAddress = this.createAddress(location?.address);
  }

  patchInPieces(inPieces) {
    this.load.inPieces = inPieces;
  }

  async getLoadData() {
    this.weightUnits = await this.loadService.getWeightUnits();
    this.measureUnits = await this.loadService.getMeasureUnits();
    this.loadTypes = await this.loadService.getLoadTypes();
  }

  async getSuggestions(query: string) {
    this.suggestions = [];
    if (!query) return;
    this.suggestions = await this.mapService.getAddressSuggestions(query);
  }

  async getAddress(object, fromElement: string) {
    const address = object.value;
    const emptyAddress: Address = this.addressFunctions.getEmptyOrFormatExistingAddress();
    const fullAddress = address !== '' ? await this.mapService.getFullAddressFromCoordinates(address) : emptyAddress;
    if (fromElement === 'postalCode') {
      if (this.activeTab === 'Clients') {
        this.client.address = fullAddress;
        this.existingAddress = this.createAddress(this.client?.address);
      }
      if (this.activeTab === 'ClientLocations') {
        this.location.address = this.addressFunctions.getEmptyOrFormatExistingAddress(fullAddress);
        this.existingAddress = this.createAddress(this.location?.address);
      }
    } else {
      if (this.activeTab === 'Clients') {
        this.client.address = fullAddress;
        this.existingAddress = this.createAddress(this.client?.address);
      }
      if (this.activeTab === 'ClientLocations') {
        this.location.address = fullAddress;
        this.existingAddress = this.createAddress(this.location?.address);
      }
    }
    this.suggestions = [];
    this.postCodes = [];
  }

  async getPostalCodeSuggestions(query: string) {
    if (query !== '') {
      this.postCodes = await this.mapService.getPostalCodeSuggestions(query);
    } else {
      const emptyAddress: Address = this.addressFunctions.getEmptyOrFormatExistingAddress();
      if (this.activeTab === 'Clients') {
        this.client.address = emptyAddress;
      }
      if (this.activeTab === 'ClientLocations') {
        this.location.address = emptyAddress;
      }
      this.postCodes = [];
      return;
    }
  }

  async findCompanies(name: string) {
    this.suggestedClients = [];
    if (!name) return;
    try {
      this.suggestedClients = await this.clientService.getClients({ name });
    } catch (e) {
      this.toasterService.createErrorToast(`Something went wrong, please try again`);
    }
  }
  selectCompany(client: Client) {
    this.location.clientId = client.id;
    this.location.client = client;
    setTimeout(() => {
      this.suggestedClients = [];
    }, 10);
  }
  createAddress(address: Address) {
    return this.addressPipe.transform(address);
  }

  async saveCargo() {
    if (this.load.name === '') {
      const errorToast: Toast = {
        title: 'Cargo name is required field!',
        type: 'Error',
        timestamp: new Date().getTime(),
      };
      this.toasterService.newToast.next(errorToast);
      return;
    }
    if (this.editCargo) {
      await this.loadService.editLoad(this.load);
      const toastMessage: Toast = {
        title: 'Cargo successfully edited!',
        type: 'Success',
        timestamp: new Date().getTime(),
      };
      this.toasterService.newToast.next(toastMessage);
    } else {
      await this.loadService.addLoad(this.load);
      const toastMessage: Toast = {
        title: 'Cargo successfully added!',
        type: 'Success',
        timestamp: new Date().getTime(),
      };
      this.toasterService.newToast.next(toastMessage);
    }
    this.router.navigate([`/${this.url}/templates`]);
    this.closePopup(true);
  }

  async saveClient() {
    if (this.client.name === '') {
      const errorToast: Toast = {
        title: 'Client name is required!',
        type: 'Error',
        timestamp: new Date().getTime(),
      };
      this.toasterService.newToast.next(errorToast);
      return;
    }
    if (this.editClient) {
      try {
        await this.clientService.editClient(this.client);
        const toastMessage: Toast = {
          title: 'Client successfully edited!',
          type: 'Success',
          timestamp: new Date().getTime(),
        };
        this.toasterService.newToast.next(toastMessage);
      } catch (e) {
        const toastMessage: Toast = {
          title: 'Something went wrong',
          type: 'Error',
          timestamp: new Date().getTime(),
        };
        this.toasterService.newToast.next(toastMessage);
        console.error(e.message);
      }
    } else {
      try {
        await this.clientService.addClient(this.client);

        const toastMessage: Toast = {
          title: 'Client successfully added!',
          type: 'Success',
          timestamp: new Date().getTime(),
        };
        this.toasterService.newToast.next(toastMessage);
      } catch (e) {
        const toastMessage: Toast = {
          title: 'Something went wrong',
          type: 'Error',
          timestamp: new Date().getTime(),
        };
        this.toasterService.newToast.next(toastMessage);
        console.error(e.message);
      }
    }
    this.router.navigate([`/${this.url}/templates`]);
    this.closePopup(true);
  }

  get hasPermissionToSetClientOnLocation(): boolean {
    return this.permissionService.hasPermission(PERMISSION_TYPE.MODULE.SHIPPER_CONTRACTOR.toString());
  }

  async saveShipperLocation() {
    await this.locationsService.addShipperLocation({
      name: this.location.name,
      address: this.location.address,
      id: this.location.id,
    });
  }

  async saveShippingLocation() {
    if (
      !this.location.name ||
      (this.hasPermissionToSetClientOnLocation && !this.location.clientId) ||
      !this.location.address.latitude ||
      !this.location.address.longitude
    ) {
      return this.toasterService.createErrorToast('All fields are required!');
    }
    if (this.edit) {
      if (!this.location.address.id) this.location.address.id = this.editShippingLocation.address.id;
      if (!this.hasPermissionToSetClientOnLocation) {
        await this.saveShipperLocation();
      } else {
        await this.locationsService.editClientLocation(this.location.id, {
          name: this.location.name,
          address: this.location.address,
          clientId: this.location.clientId,
          id: this.location.id,
        });
      }
      this.edit = false;
      const toastMessage: Toast = {
        title: 'Shipping location successfully edited!',
        type: 'Success',
        timestamp: new Date().getTime(),
      };
      this.toasterService.newToast.next(toastMessage);
    } else {
      if (!this.location.address.id) delete this.location.address.id;
      if (!this.hasPermissionToSetClientOnLocation) {
        await this.saveShipperLocation();
      } else {
        await this.locationsService.addClientLocation({
          name: this.location.name,
          address: this.location.address,
          clientId: this.location.clientId,
          id: this.location.id,
        });
      }
      this.edit = false;
      const toastMessage: Toast = {
        title: 'Shipping location successfully added!',
        type: 'Success',
        timestamp: new Date().getTime(),
      };
      this.toasterService.newToast.next(toastMessage);
    }
    this.closePopup(true);
  }

  closePopup(isAdded?: boolean) {
    const trigger = 'closePopup';
    const data = isAdded;
    this.branch = null;
    this.client = null;
    this.location = null;
    this.triggerEmitter.emit({ trigger, data });
  }
}
